import { render, staticRenderFns } from "./videoPlayer.vue?vue&type=template&id=28d888bc&scoped=true&"
import script from "./videoPlayer.vue?vue&type=script&lang=js&"
export * from "./videoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./videoPlayer.vue?vue&type=style&index=0&id=28d888bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d888bc",
  null
  
)

export default component.exports